import isEqual from 'lodash-es/isEqual';
import Boss from '@tencent/vft-common/Boss';
import { EventType } from "../../defs";
/**
 *
 * @description 用于单boss上报
 */
export default class BossClient {
    constructor({ event, pv }) {
        this.eventBoss = new Boss(event);
        if (pv && !isEqual(event, pv)) {
            this.pvBoss = new Boss(pv);
        }
    }
    report(params, event) {
        this.eventBoss.report(params);
        if (event === EventType.EXPOSE && this.pvBoss) {
            this.pvBoss.report(params);
        }
    }
}
